import React, { useRef, Suspense } from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import styles from './PostHero.module.scss';
import { Heading, Text } from '../index';
import { Spacer, TableOfContents } from '../lazyComponents';
import { t } from '@konrad/reweb-aem';
import { capitalize } from '../../lib/helpers/stringHeplers';
import ShareLinks from '../ShareLinks';
import { LinkBase } from '../_shared/Link';
import { PRESS_RELEASE } from '../../lib/constants';

const PostHero = (props) => {
    const { category, title, image, readTime, altText, date } = props;
    const post = props.posts.length !== 0 ? props.posts[0] : null;
    const detailsContent = `<p>${capitalize(date)} • ${t('fs.post.read-time', [
        readTime || 3,
    ])}</p>`;

    const isPresRelease =
        category.toUpperCase() === PRESS_RELEASE.EN || category.toUpperCase() === PRESS_RELEASE.FR;
    const containerRef = useRef();

    return (
        <div
            className={cx(
                styles['main-container'],
                !isPresRelease && styles['main-container-table']
            )}
            ref={containerRef}
        >
            <div className={cx(styles.container)}>
                <Heading
                    headingLevel="div"
                    overrideStyle="large"
                    color="darkPurple"
                    text={category}
                    className={styles['category']}
                    hideFromTableOfContent={true}
                />
                <Heading
                    headingLevel="h1"
                    overrideStyle="h3"
                    color="darkPurple"
                    text={title}
                    className={styles['title']}
                    hideFromTableOfContent={true}
                />
                <div className={cx(styles['bottom-content'])}>
                    <div className={cx(styles['bottom-content-left'])}>
                        {post && (
                            <div className={cx(styles['bottom-content-left-author'])}>
                                <div
                                    role={altText ? 'img' : ''}
                                    className={cx(styles['author-image'])}
                                    style={{
                                        backgroundImage: `url('${post.image}')`,
                                    }}
                                />
                                <LinkBase
                                    addIdSuffix={true}
                                    url={post.postUrl}
                                    className={styles['bottom-content-left-bio']}
                                >
                                    <Text content={post.author} size="small" />
                                </LinkBase>
                            </div>
                        )}
                        <Text
                            content={detailsContent}
                            size="small"
                            className={cx(styles['bottom-content-left-details'])}
                        />
                    </div>
                    <ShareLinks />
                </div>
                {image ? (
                    <div
                        role={altText ? 'img' : ''}
                        aria-label={altText}
                        className={cx(styles['image'])}
                        style={{
                            backgroundImage: `url('${image}')`,
                        }}
                    />
                ) : (
                    <Suspense fallback={''}>
                        <Spacer spacerSize={'spacingM'} />
                    </Suspense>
                )}
            </div>
            <Suspense fallback={''}>
                {!isPresRelease && (
                    <TableOfContents
                        className={styles['table-content']}
                        containerRef={containerRef}
                    />
                )}
            </Suspense>
        </div>
    );
};

PostHero.displayName = 'PostHero';

PostHero.propTypes = {
    category: PropTypes.string,
    title: PropTypes.string,
    image: PropTypes.string,
    readTime: PropTypes.string,
    altText: PropTypes.string,
    date: PropTypes.string,
};

export default PostHero;
